<template>
    <footer class="content-footer" v-show="!loading">
      <div class="content-footer-itens container">
        <div class="content-footer-itens-text v-content-footer" v-contentFooter="{ section: 'Footer', removeHtml: true }">
          ©️ Freebee, {{ new Date().getFullYear() }}
        </div>
        <div class="content-footer-itens-links">
          <router-link to="/terminos-y-condiciones" class="content-footer-itens-text v-content-footer pr-5" v-contentFooter="{ section: 'Footer', removeHtml: true }">
            Termos e Condições
          </router-link>
          <router-link to="/politica-de-privacidad" class="content-footer-itens-text v-content-footer" v-contentFooter="{ section: 'Footer', removeHtml: true }">
            Política de Privacidade
          </router-link>
        </div>
      </div>
    </footer>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import axios from 'axios';
  import store from '@/store';
  
  const allContents = [];
  const lang = localStorage.getItem('locale') || 'es';
  
  export default {
    computed: {
      ...mapState('App', ['loading']),
    },
    directives: {
      contentFooter: {
        inserted: async function (el, binding) {
          const allElements = document.querySelectorAll('.v-content-footer');
          let params = binding.value ? binding.value : {};
          params.content = el.innerHTML.trim();
          (!('type' in params) ? params.type = 'text' : null);
          params.theme = process.env.VUE_APP_THEME;
          params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
          allContents.push(params);
  
          if (allElements.length == allContents.length) {
            store.dispatch('App/loading', true);
            await axios({
              method: "POST",
              url: '/api/v1/site/get-all-contents',
              data: { allContents, lang }
            })
              .then(response => response.data)
              .then((data) => {
  
                const allElements = document.querySelectorAll('.v-content-footer');
                allContents.forEach((el) => {
                  if (el.type == 'text') {
                    allElements.forEach((el, index) => {
                      el.innerHTML = data.data[index];
                    });
                  }
                });
                store.dispatch('App/loading', false);
              });
          }
        },
  
      }
    },
  };
  
  </script>
  
  <style lang="scss">
  .content-footer{
    width: 100%;
    height: 88px;
    background-color: var(--main-color);
    display: flex;
    justify-content: center;
    align-items: center;
    &-itens{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      @media screen and (max-width: 991px) {
        justify-content: center;
      }
      &-text{
        font-family: 'Font Regular';
        font-size: 16px;
        line-height: 26px;
        color: var(--white);
        @media screen and (max-width: 991px) {
          font-size: 10px;
          line-height: 16px;
        }
      }
      &-links{
        display: flex;
        @media screen and (max-width: 991px) {
          display: none;
        }
        a{
          text-decoration: none;
          color: var(--white);
          font-family: 'Font Regular';
          font-size: 16px;  
          line-height: 26px;
          @media screen and (max-width: 991px) {
            font-size: 10px;
            line-height: 16px;
          }
        }
      }
    }
  }
  </style>